import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';
import { IonButton, IonIcon, ModalController } from '@ionic/angular/standalone';
import { TranslateModule } from '@ngx-translate/core';
import { IUser } from '@okcargo-apps/shared-domain';
import { UserEditModalComponent } from '../user-edit-modal/user-edit-modal.component';

@Component({
  selector: 'lib-user-edit-action',
  templateUrl: './user-edit-action.component.html',
  styleUrls: ['./user-edit-action.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [IonButton, IonIcon, TranslateModule],
})
export class UserEditActionComponent {
  public readonly user = input.required<IUser>();

  private readonly modalCtrl = inject(ModalController);

  public async openEditModal(): Promise<void> {
    const modal = await this.modalCtrl.create({
      component: UserEditModalComponent,
      componentProps: { user: this.user() },
      backdropDismiss: false,
    });

    await modal.present();
  }
}
